import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=3e9d2160&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=3e9d2160&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9d2160",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e9d2160')) {
      api.createRecord('3e9d2160', component.options)
    } else {
      api.reload('3e9d2160', component.options)
    }
    module.hot.accept("./UserLayout.vue?vue&type=template&id=3e9d2160&scoped=true", function () {
      api.rerender('3e9d2160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/UserLayout.vue"
export default component.exports